import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Progress from './progress';

import { 
  // actions
  closePopup,
  //selectors
  isOpenedSelector, loadingSelector, contentSelector, classValueSelector, errorSelector 
} from '../../ducks/popup';


export default function Popup(props) {
  const dispatch = useDispatch();
  const isOpen = useSelector(isOpenedSelector);
  const content = useSelector(contentSelector);
  const loading = useSelector(loadingSelector);
  const classValue = useSelector(classValueSelector);
  const error = useSelector(errorSelector);

  const handleClosePopup = () => dispatch(closePopup());

  const getBody = () => {
    if (loading) return <Progress />;
    if (error) return <div>Oops, something happend wrong</div>
    return <div dangerouslySetInnerHTML={{__html: content }} />;
  }

  const getOtherProps = () => {
    const props = {};
    
    if (classValue) props.className = classValue;

    return props;
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClosePopup}
      {...getOtherProps()}
    >
      <DialogContent>
        { getBody() }
      </DialogContent>
      <DialogActions>
        { !loading && <Button color="primary" onClick={handleClosePopup}>Close</Button> }
      </DialogActions>
    </Dialog>
  )
}